import CTA14_morph from './CTA14_morph'
export default CTA14_morph
